// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getAuditPreparationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';

export const resetAuditPreparation = () => ({
    data: getAuditPreparationDefaultState(),
    type: actions.RESET_TCSM_PREPARE_AUDIT_AUDIT
});



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/reset-audit-preparation.js